<template>
  <div style="margin: 25px">
    <vue-good-table
      :columns="alimListesicolumns"
      :rows="alimListesi"
      :rtl="dir"
      max-height="350px"
      :fixed-header="true"
      :row-style-class="rowStyleClassFn"
    >
      <template slot="table-row" slot-scope="props">
        <!-- Column: Name -->
        <div v-if="props.column.field === 'TRANSDATE'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.TRANSDATE }}</span>
        </div>
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-row>
              <b-col lg="12" sm="12">
                <vs-button
                  @click="
                    alimSec(
                      props.row.ACTID,
                      props.row.ACTNAME,
                      props.row.STOCKID
                    )
                  "
                  color="success"
                  type="flat"
                  size="small"
                  icon="add_shopping_cart"
                ></vs-button>
              </b-col>
            </b-row>
          </span>
        </span>
      </template>
      
      <!-- pagination -->
    </vue-good-table>
    <SepeteEkle ref="sepet" />
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import SepeteEkle from "./SepeteEkle.vue";
export default {
  data() {
    return {
      dir: false,
      alimListesi: [],
      alimListesicolumns: [
        {
          label: "Tarih",
          field: "TRANSDATE",
        },
        {
          label: "Cari Adı",
          field: "ACTNAME",
        },
        {
          label: "Belge No",
          field: "ROOTRECEIPTNO",
        },
        {
          label: "Adet",
          field: "QENTRY",
        },
        {
          label: "Fiyat",
          field: "PRICE",
        },
        {
          label: "Talep",
          field: "TALEP",
        },
        {
          field: "action",
          label: "Seç",
        },
      ],
    };
  },
  methods: {
    rowStyleClassFn(row) {
      return "VGT-row";
    },
    //talep havuzuna gönderirken
    alimSec(ACTID, ACTNAME, STOCKID) {
      this.$store.commit("account/SEPETACTNAME_TUT", ACTNAME);
      this.$store.commit("account/SEPETACTID_TUT", ACTID);
      this.$store.commit("account/SEPETSTOKID_TUT", STOCKID);

      this.$refs.sepet.sepet();
    },
    alimList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        STOCKID: Store.state.account.stokId,
      };

      soap.createClient(url, function (err, client) {
        client.INT_Ls_StockEktsre_Alimlar(args, function (err, result) {
          if (result.INT_Ls_StockEktsre_AlimlarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.INT_Ls_StockEktsre_AlimlarResult);
          vm.alimListesi = vm.veriler;
          // vm.rowData = vm.veriler;
        });
      });
    },
  },
  components: { SepeteEkle },
  created() {
    this.alimList();
  },
};
</script>
<style lang="scss">
.includeIconOnly.small .vs-icon {
  font-size: 1.5rem;
}
.VGT-row:hover {
  background-color: rgb(219, 219, 250);
}
</style>
